export default __webpack_public_path__ + "images/product/skin_types/dry-25a1b305ebc0c2a04d950c6a4e8e3b2b.svg";